// How a recorded test (a row from GET /load-tests, the History list's shape)
// is named and described on the History pages.

// Start and end times are the logger's own clock, sent without a time zone,
// so they are shown as written.
export function parseLocal(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d : null;
}

export function formatDate(d) {
  return d ? d.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' }) : '—';
}

export function formatTime(d) {
  return d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : '';
}

export function formatDuration(minutes) {
  if (minutes === null || minutes === undefined) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}m`;
}

// "Revere High School · LT4 · test 1", or "No job set · MK011" when the test
// has no job.
export function testTitle(test) {
  if (!test) return '';
  const job = test.project_name || (test.job_number ? `Job ${test.job_number}` : null);
  const rest = [test.point_number, test.test_number != null ? `test ${test.test_number}` : null];
  return job ? [job, ...rest].filter(Boolean).join(' · ') : ['No job set', test.logger_name, ...rest].filter(Boolean).join(' · ');
}

// "Apr 23, 2026 08:58–16:41 · Test Box 1 · MK011 · 263 kips peak · 7h 43m"
export function testSummary(test, units) {
  if (!test) return '';
  const start = parseLocal(test.start_time);
  const end = parseLocal(test.end_time);
  const when = start ? `${formatDate(start)} ${formatTime(start)}${end ? `–${formatTime(end)}` : ''}` : null;
  const peak = test.peak_kips == null ? null
    : units ? `${units.fmtForce(test.peak_kips)} ${units.forceUnit} peak` : `${Math.round(test.peak_kips)} kips peak`;
  return [when, test.box_name, test.logger_name, peak, test.duration_min != null ? formatDuration(test.duration_min) : null]
    .filter(Boolean).join(' · ');
}

// When a revision was saved, e.g. "Oct 15, 10:12" (in the viewer's time zone:
// revisions are stamped by the server in UTC).
export function formatSavedAt(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime())
    ? d.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })
    : '';
}

export const historyTestPath = (testId) => `/operations/load-test/history/${testId}`;
export const historyRevisionPath = (testId, revisionId) => `/operations/load-test/history/${testId}/rev/${revisionId}`;
